import { Controller, useFormContext } from 'react-hook-form';
import { Tooltip } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { ModifyWantedInformationBody } from 'api/wanted/wanted.types';
import * as Styled from '../WantedTableRow.styles';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { ModifyWantedInformationProps } from './ModifyWantedInformation.types';

export const ModifyWantedInformation = ({
  owner,
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: ModifyWantedInformationProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.POSZUKIWANY]?.edit;

  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useFormContext<ModifyWantedInformationBody>();

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Styled.InformationIcon
          onClick={isPermsDisabled ? undefined : onModalOpen}
          tabIndex={isPermsDisabled ? -1 : 0}
          disabled={isPermsDisabled}
        />
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['wanted.modify.information.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isLoading || !isValid}
        submitButtonText={formatMessage({ id: AppMessages['common.save'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['wanted.modify.information.subtitle'] })}
            {`${owner.nazwisko || ''} ${owner.imie || ''}`}
          </ActionModal.Subtitle>

          <Controller
            name="informacja"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['wanted.modify.information.label'] })}
                placeholder={formatMessage({ id: AppMessages['wanted.modify.information.placeholder'] })}
                required
                errorMessage={error?.message}
              />
            )}
          />
        </>
      </ActionModal>
    </>
  );
};
